import { Icon } from '../components';
import { KnowledgeHubRecordType } from '../types';

/**
 * Returns the appropriate icon for a given knowledge hub record type.
 * This is implemented as a function rather than a constant to ensure proper component mounting
 * before the icons are referenced in the UI.
 */
export const getKnowledgeHubIcon = (type: KnowledgeHubRecordType): Icon => {
  switch (type) {
    case KnowledgeHubRecordType.PRIORITY:
      return Icon.PRIORITIES;
    case KnowledgeHubRecordType.OBJECTION:
      return Icon.OBJECTIONS;
    case KnowledgeHubRecordType.QUESTION:
      return Icon.QUESTIONS;
    case KnowledgeHubRecordType.HIDDEN_CONTEXT:
      return Icon.HIDDEN_GEMS;
  }
};
